var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 262,
    viewBox: "0 0 330 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.996 29.9554C61.058 2.4625 21.1686 -2.09283 8.56118 15.1952C-9.87926 40.4819 45.1169 112.124 131.399 175.213C217.68 238.301 302.574 268.946 321.015 243.659C333.181 226.975 317.159 192.318 277.496 151.046M98.7857 39.4872C60.7224 21.1705 32.0224 15.1082 24.0424 26.0509C10.3744 44.7933 62.667 106.325 140.841 163.485C219.015 220.645 293.468 251.789 307.136 233.046C314.92 222.373 301.313 197.824 273.717 168.108M277.495 139.693C277.495 204.48 225.045 257 160.345 257C95.6439 257 43.1937 204.48 43.1937 139.693C43.1937 74.9069 95.6439 22.387 160.345 22.387C225.045 22.387 277.495 74.9069 277.495 139.693Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.32b9fcac3bd32e8e4f2d9cfc3a940e09.svg";
export { ForwardRef as ReactComponent };